export const serializeFiltersToQuery = (filters) => {
    const params = new URLSearchParams();

    if (filters.search?.trim()) {
        params.set('se', filters.search.trim());
    }

    const addSet = (key, set) => {
        if (set && set.size > 0) {
            params.set(key, Array.from(set).join(','));
        }
    };

    addSet('sp', filters?.species);
    addSet('m', filters?.manufacturerIds);
    if (filters?.taxonomyTree?.macrofamilyId) {
        params.set('tmf', filters?.taxonomyTree?.macrofamilyId);
    }
    if (filters?.taxonomyTree?.familyId) {
        params.set('tf', filters?.taxonomyTree?.familyId);
    }
    addSet('tsf', filters?.taxonomyTree?.subfamilyIds);

    const characteristics = filters?.characteristics;
    if (characteristics) {
        if (characteristics.featured !== null && characteristics.featured !== undefined) {
            params.set('cf', characteristics.featured);
        }
        if (characteristics.prescription !== null && characteristics.prescription !== undefined) {
            params.set('cp', characteristics.prescription);
        }
        if (characteristics.hasCombinable !== null && characteristics.hasCombinable !== undefined) {
            params.set('cc', characteristics.hasCombinable);
        }
        if (characteristics.hasActiveLotPromotion !== null && characteristics.hasActiveLotPromotion !== undefined) {
            params.set('cal', characteristics.hasActiveLotPromotion);
        }
        if (characteristics.isNew !== null && characteristics.isNew !== undefined) {
            params.set('cn', characteristics.isNew);
        }
    }

    return params;
};

// Devuelve SOLO las claves con valor real (URL limpia => {}). Antes devolvia siempre las 5
// claves con vacios (search:'', Sets vacios, nulls) y ese objeto "ruidoso" no era igual al
// contexto limpio {}: cada pasada URL->contexto->URL producia objetos distintos y refetches
// en cadena al vaciar los filtros.
export const parseQueryToFilters = (searchParams) => {
    const getSet = (key, isNumber = true) => {
        const val = searchParams.get(key);
        if (!val) return new Set();
        return new Set(val.split(',').map(v => isNumber ? Number(v) : v));
    };
    const getBool = (key) => searchParams.get(key) ? searchParams.get(key) === 'true' : null;

    const filters = {};

    const search = searchParams.get('se');
    if (search) filters.search = search;

    const species = getSet('sp', false);
    if (species.size) filters.species = species;

    const manufacturerIds = getSet('m');
    if (manufacturerIds.size) filters.manufacturerIds = manufacturerIds;

    const macrofamilyId = searchParams.get('tmf') ? Number(searchParams.get('tmf')) : null;
    const familyId = searchParams.get('tf') ? Number(searchParams.get('tf')) : null;
    const subfamilyIds = getSet('tsf');
    if (macrofamilyId || familyId || subfamilyIds.size) {
        filters.taxonomyTree = { macrofamilyId, familyId, subfamilyIds };
    }

    const characteristics = {};
    [['cf', 'featured'], ['cp', 'prescription'], ['cc', 'hasCombinable'],
     ['cal', 'hasActiveLotPromotion'], ['cn', 'isNew']].forEach(([param, key]) => {
        const value = getBool(param);
        if (value != null) characteristics[key] = value;
    });
    if (Object.keys(characteristics).length) filters.characteristics = characteristics;

    return filters;
};
